import { v4 as uuidv4 } from 'uuid';
import { each } from 'bluebird';
import store from '../reducers/storeRegistration';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
import notificationActions from '../actions/notificationActionCreators';
import reportActionCreators from '../actions/reportActionCreators';
import issueActionCreators from '../actions/issueActionCreators';
import jobActionCreators from '../actions/jobActionCreators';
import formActionCreators from '../actions/formActionCreators';
const actionCreators = {
  report: reportActionCreators,
  issue: issueActionCreators,
  job: jobActionCreators,
  form: formActionCreators
};
const GOLD = 'primary';
const RED = 'danger';
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  const entityActions = actionCreators[entityName];
  const title = source.title,
    message = source.message,
    options = source.options;
  const evaluatedMessage = message && typeof message === 'object' ? await evaluateSource(message, content, parentContentPath, transientContext, nativeFunctions) : message;
  const alertId = uuidv4();
  const afterButtonAction = async () => {
    // @NOTE (trs) dismiss the notification after an action button is clicked.
    await store.dispatch(notificationActions.dismiss(alertId));
    // @NOTE (trs) it is essential to call formatChange
    // otherwise, any effect it has on `active.content` will not be visible.
    await store.dispatch(entityActions.formatChange(alertId));
  };
  let leftButtonLabel = '';
  let leftButtonAction = () => {};
  let leftButtonColor = GOLD;
  let middleButtonLabel = '';
  let middleButtonAction = () => {};
  let middleButtonColor = GOLD;
  let rightButtonLabel = '';
  let rightButtonAction = () => {};
  let rightButtonColor = GOLD;
  if (options && options.length) {
    const _options$ = options[0],
      left = _options$.title,
      leftActions = _options$.actions,
      leftDestructive = _options$.destructive;
    leftButtonAction = async () => {
      if (leftActions) {
        await each(leftActions, async action => {
          // evaluate each of the format `actions` when the button is selected
          await evaluateSource(action, content, parentContentPath, transientContext, nativeFunctions);
        });
      }
      await afterButtonAction();
    };
    leftButtonLabel = left && typeof left === 'object' ? await evaluateSource(left, content, parentContentPath, transientContext, nativeFunctions) : left;
    if (leftDestructive) leftButtonColor = RED;
    if (options.length === 2) {
      const _options$2 = options[1],
        right = _options$2.title,
        rightActions = _options$2.actions,
        rightDestructive = _options$2.destructive;
      rightButtonLabel = right && typeof right === 'object' ? await evaluateSource(right, content, parentContentPath, transientContext, nativeFunctions) : right;
      rightButtonAction = async () => {
        if (rightActions) {
          await each(rightActions, async action => {
            // evaluate each of the format `actions` when the button is selected
            await evaluateSource(action, content, parentContentPath, transientContext, nativeFunctions);
          });
        }
        await afterButtonAction();
      };
      if (rightDestructive) rightButtonColor = RED;
    } else if (options.length > 2) {
      // we only support three buttons at this time.
      const _options$3 = options[1],
        mid = _options$3.title,
        midActions = _options$3.actions,
        midDestructive = _options$3.destructive;
      middleButtonLabel = mid && typeof mid === 'object' ? await evaluateSource(mid, content, parentContentPath, transientContext, nativeFunctions) : mid;
      middleButtonAction = async () => {
        if (midActions) {
          await each(midActions, async action => {
            // evaluate each of the format `actions` when the button is selected
            await evaluateSource(action, content, parentContentPath, transientContext, nativeFunctions);
          });
        }
        await afterButtonAction();
      };
      if (midDestructive) middleButtonColor = RED;
      const _options$4 = options[2],
        right = _options$4.title,
        rightActions = _options$4.actions,
        rightDestructive = _options$4.destructive;
      rightButtonLabel = right && typeof right === 'object' ? await evaluateSource(right, content, parentContentPath, transientContext, nativeFunctions) : right;
      rightButtonAction = async () => {
        if (rightActions) {
          await each(rightActions, async action => {
            // evaluate each of the format `actions` when the button is selected
            await evaluateSource(action, content, parentContentPath, transientContext, nativeFunctions);
          });
        }
        await afterButtonAction();
      };
      if (rightDestructive) rightButtonColor = RED;
    }
  } else {
    // if we have no buttons (format.options), call the cleanup method.
    await afterButtonAction();
  }
  await store.dispatch(notificationActions.block({
    id: alertId,
    headerMessage: title,
    message: evaluatedMessage,
    leftButtonLabel,
    leftButtonAction,
    leftButtonColor,
    middleButtonLabel,
    middleButtonAction,
    middleButtonColor,
    rightButtonLabel,
    rightButtonAction,
    rightButtonColor
  }, {
    autoClose: options.length === 0
  }));
};
export default {
  evaluate
};